/*       */

function quesk () {
  var queue               = [];

  return {
    append: function append (el     )         {
      return queue.push(el)
    },

    prepend: function prepend (el     )         {
      return queue.unshift(el)
    },

    pop: function pop ()      {
      return queue.pop()
    },

    shift: function shift ()      {
      queue.shift();
    },

    first: function first ()      {
      return queue[0]
    },

    last: function last ()      {
      return queue.slice(-1)[0]
    },

    all: function all ()               {
      return queue
    },

    length: function length ()         {
      return queue.length
    }
  }
}

module.exports = quesk;
//# sourceMappingURL=quesk.js.map
